var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "unit-settings" },
    [
      _c("Card", [
        _c(
          "h2",
          { staticClass: "unit-settings__card-title typographies-heading-h2" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t.__("settings.units.unit_settings.title")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "unit-settings__row" },
          [
            _c(
              "CompassFormItem",
              {
                attrs: {
                  label: _vm.$t.__(
                    "settings.units.unit_settings.unit_column.label"
                  )
                }
              },
              [
                _vm.isLoadingUnitSettings
                  ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
                  : _c(
                      "CompassRadioGroup",
                      {
                        attrs: { label: "", direction: "horizontal" },
                        model: {
                          value: _vm.unitColumn,
                          callback: function($$v) {
                            _vm.unitColumn = $$v
                          },
                          expression: "unitColumn"
                        }
                      },
                      _vm._l(Object.keys(_vm.unitColumns), function(item) {
                        return _c("CompassRadio", {
                          key: _vm.unitColumns[item].value,
                          attrs: {
                            label: _vm.unitColumns[item].label,
                            modelValue: _vm.unitColumns[item].value
                          }
                        })
                      }),
                      1
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassFormItem",
              {
                staticClass: "unit-precision",
                attrs: {
                  label: _vm.$t.__(
                    "settings.units.unit_settings.unit_precision.label"
                  )
                }
              },
              [
                _vm.isLoadingUnitSettings
                  ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
                  : _c(
                      "CompassSelect",
                      {
                        model: {
                          value: _vm.unitAmountPrecision,
                          callback: function($$v) {
                            _vm.unitAmountPrecision = $$v
                          },
                          expression: "unitAmountPrecision"
                        }
                      },
                      _vm._l(_vm.unitAmountPrecisionList, function(unitAmount) {
                        return _c("CompassDropdownSelectOption", {
                          key: unitAmount,
                          attrs: {
                            label: _vm.formatPrecision(unitAmount),
                            value: unitAmount
                          }
                        })
                      }),
                      1
                    )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "h2",
          { staticClass: "unit-settings__card-title typographies-heading-h2" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t.__("settings.units.measurement_units.title")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t.__("settings.units.measurement_units.description")
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "unit-settings__row" },
          [
            _c(
              "CompassFormItem",
              {
                attrs: {
                  label: _vm.$t.__(
                    "settings.units.measurement_units.measurement_units.label"
                  )
                }
              },
              [
                _vm.isLoadingUnitSettings
                  ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
                  : _c(
                      "CompassSelect",
                      {
                        model: {
                          value: _vm.dimensionUnit,
                          callback: function($$v) {
                            _vm.dimensionUnit = $$v
                          },
                          expression: "dimensionUnit"
                        }
                      },
                      _vm._l(Object.keys(_vm.dimensionUnits), function(item) {
                        return _c("CompassDropdownSelectOption", {
                          key: _vm.dimensionUnits[item].value,
                          attrs: {
                            label: _vm.dimensionUnits[item].label,
                            value: _vm.dimensionUnits[item].value
                          }
                        })
                      }),
                      1
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassFormItem",
              {
                attrs: {
                  label: _vm.$t.__(
                    "settings.units.measurement_units.weight_units.label"
                  )
                }
              },
              [
                _vm.isLoadingUnitSettings
                  ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
                  : _c(
                      "CompassSelect",
                      {
                        model: {
                          value: _vm.weightUnit,
                          callback: function($$v) {
                            _vm.weightUnit = $$v
                          },
                          expression: "weightUnit"
                        }
                      },
                      _vm._l(Object.keys(_vm.weightUnits), function(item) {
                        return _c("CompassDropdownSelectOption", {
                          key: _vm.weightUnits[item].value,
                          attrs: {
                            label: _vm.weightUnits[item].label,
                            value: _vm.weightUnits[item].value
                          }
                        })
                      }),
                      1
                    )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "unit-settings__actions" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.labels.save_changes"),
                disabled: _vm.isLoadingUnitSettings,
                loading: _vm.isSavingSettings
              },
              on: { click: _vm.handleUnitSettingsSave }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "Card",
        [
          _c(
            "h2",
            {
              staticClass: "unit-settings__card-title typographies-heading-h2"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t.__("settings.units.unit_list.title")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _vm.showUnitCode
            ? _c("CompassAlert", {
                attrs: {
                  customIcon:
                    "/ressources/logged/img/icon/svg/info-e-invoicing.svg",
                  description: _vm.$t.__(
                    "settings.units.unit_list.alert.description"
                  ),
                  type: "neutral",
                  action: {
                    label: _vm.$t.__("settings.units.unit_list.alert.action"),
                    callback: _vm.consultCodeList
                  },
                  actionPosition: "bottom",
                  showClose: false
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t.__("settings.units.unit_list.description")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "CompassTabs",
            {
              key: _vm.languages.length,
              model: {
                value: _vm.currentTab,
                callback: function($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab"
              }
            },
            [
              _c(
                "CompassTabPane",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.by_default"),
                    name: "default",
                    icon: "flag-fill",
                    isError: _vm.hasErrors
                  }
                },
                [
                  _vm.isLoading
                    ? _c("TableLoading")
                    : _c("UnitTable", {
                        attrs: {
                          units: _vm.editableUnits,
                          canEditUnit: _vm.isAdmin,
                          isEditable: _vm.isEditable,
                          editMode: _vm.editMode,
                          unit: _vm.unit,
                          showUnitCode: _vm.showUnitCode
                        },
                        on: {
                          "update:unit": _vm.handleUpdateDefaultUnit,
                          addUnit: _vm.handleAddUnit,
                          removeUnit: _vm.handleRemoveUnit,
                          sort: _vm.handleSortUpdate
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.languages, function(language) {
                return _c(
                  "CompassTabPane",
                  {
                    key: language.id,
                    attrs: {
                      label: language.lang,
                      name: language.lang,
                      customIcon: _vm.getLanguageIcon(language)
                    }
                  },
                  [
                    _vm.isLoading
                      ? _c("TableLoading")
                      : _c("UnitTranslationTable", {
                          attrs: {
                            units: _vm.editableUnits,
                            isEditable: _vm.isEditable,
                            editMode: _vm.editMode,
                            language: language.id
                          },
                          on: {
                            sort: _vm.handleSortUpdate,
                            addUnit: _vm.handleAddUnit
                          }
                        })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "unit-settings__actions" },
            [
              !_vm.editMode
                ? _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("settings.units.unit_list.edit_button"),
                      type: "secondary",
                      disabled: !_vm.isAdmin || _vm.isLoading,
                      loading: _vm.isLoadingEditMode
                    },
                    on: { click: _vm.startEditMode }
                  })
                : [
                    _c("CompassPlainButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        variant: "neutral",
                        loading: _vm.unitListSaving
                      },
                      on: { click: _vm.handleCancelEditMode }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.save"),
                        type: "primary",
                        loading: _vm.unitListSaving
                      },
                      on: { click: _vm.handleUnitListSave }
                    })
                  ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }